import React from 'react';
import { useTranslations } from '../../localization/useTranslations';
import Button from '../../components/buttons/SimpleButton/Button';

interface PaymentFooterProps {
  failed: boolean;
}

const PaymentFooter: React.FC<PaymentFooterProps> = ({ failed }) => {
  const translations = useTranslations();

  return (
    <>
      {!failed && (
        <div className="section section--footer-button h-flex h-justify-content--center">
          <Button
            href="/"
            className=""
            label={translations?.salesFunnel?.footerButtonText || 'Go to homepage'}
            type="secondary"
            size="large"
          />
        </div>
      )}
      <div className="section section--footer-contact h-text--center h-border--none">
        <p className="basic-16">{translations?.salesFunnel?.footerLabel || 'Do you need help?'}</p>

        <p className="link-16">
          {translations?.salesFunnel?.footerContactLabel || 'Contact us at'}{' '}
          <a
            className="h-color--text-primary link-underline-16"
            href={`mailto:${translations?.salesFunnel?.footerEmail}`}
          >
            {translations?.salesFunnel?.footerEmail || 'predplatne@forbes.cz'}
          </a>
        </p>
      </div>
    </>
  );
};

export default PaymentFooter;
